import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathControlPromptTemplates(templateId=null) {
  if (templateId) {
      return `control/prompt-templates/${templateId}`;
  } else {
      return `control/prompt-templates`;
  }
}

export function createControlPromptTemplates(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlPromptTemplates(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchControlPromptTemplates(successCallback, errorCallback, data, templateId) {
  patchAuth({
    "path": pathControlPromptTemplates(templateId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlPromptTemplates(successCallback, errorCallback, templateId) {
  deleteAuth({
    "path": pathControlPromptTemplates(templateId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function reorderControlPromptTemplates(successCallback, errorCallback, data, templateId) {
  postAuth({
    "path": `control/prompt-templates/${templateId}/reorder`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewControlManagePromptTemplates(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-prompt-templates`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewControlPromptTemplateEditor(templateId=null) {
  if (templateId) {
      return `view/control/prompt-template-editor/${templateId}`;
  } else {
      return `view/control/prompt-template-editor`;
  }
}

export function getViewControlPromptTemplateEditor(successCallback, errorCallback, templateId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewControlPromptTemplateEditor(templateId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


